import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { introHomePage } from "i18n/homePage";
import CTAButton from "Util/CTAButton";
import { ArrowRight, Compass, Info } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const Intro = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = introHomePage[lang];
  const navigate = useNavigate();

  const slides = [
    "/maria/banner/MP1.png",
    "/maria/banner/MP3.png",
    "/maria/banner/MP4.png",
    "/maria/banner/MP5.png",
    "/maria/banner/MP6.png",
    "/maria/banner/MP7.png",
  ];

  const Content = ({ navigate }) => (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      className="
      bg-none lg:bg-darkbg/95
      backdrop-blur-md
      text-white
      p:0 lg:p-10
      rounded-xl
      lg:shadow-2xl
    "
    >
      <h2 className="text-3xl lg:text-4xl font-heading mb-6 animate-neonFlicker ">
        {t.title}
      </h2>

      <p className="leading-relaxed mb-5 text-text">{t.p1}</p>

      <p className="leading-relaxed mb-6 text-text">{t.p2}</p>

      <div className="grid grid-cols-3 gap-3 mb-8">
        {t.hightlight?.map((item, index) => (
          <div
            key={index}
            className="
        rounded-lg
        border border-[#d8d0c8]
        bg-[#f3eee8]
        text-center
        py-2 px-2
        shadow-sm
      "
          >
            <div className="text-xl font-bold text-reddark leading-none">
              {item.value}
            </div>

            <div className="text-[11px] lg:text-xs text-textGray mt-1">
              {item.label}
            </div>
          </div>
        ))}
      </div>

      <CTAButton
        variant="primary"
        icon={Info}
        text={t.cta}
        onClick={() => navigate("/about")}
      />
    </motion.div>
  );

  return (
    <section className="relative w-full overflow-hidden">
      <div className="hidden lg:block relative max-w-8xl h-[100vh] mx-auto">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          effect="fade"
          loop
          speed={1200}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className} custom-bullet"></span>`;
            },
          }}
          navigation
          className="w-full h-full"
        >
          {slides.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-full overflow-hidden">
                <img
                  src={image}
                  alt="Maria Advisory"
                  className="
              w-full h-full
              object-cover
              scale-105
              animate-[slowZoom_8s_linear_forwards]
            "
                />

                <div
                  className="
              absolute inset-0
              bg-[linear-gradient(to_right,rgba(0,0,0,0.05)_45%,rgba(241,238,233,0.65)_75%,rgba(241,238,233,1)_100%)]
            "
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className="absolute inset-0 
  bg-[linear-gradient(to_right,rgba(0,0,0,0)_50%,rgba(241,238,233,0.7)_75%,rgba(241,238,233,1)_100%)]"
        />{" "}
      </div>

      <div className="hidden lg:flex absolute inset-0 items-end justify-end pr-72 z-10 mb-10">
        <div className="max-w-xl">
          <Content navigate={navigate} />
        </div>
      </div>

      {/* ===== MOBILE GRID VERSION ===== */}
      <div className="lg:hidden flex flex-col">
        <div className="relative w-full h-full">
          <Swiper
            modules={[Autoplay, Pagination]}
            loop
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              renderBullet: (index, className) => {
                return `<span class="${className} custom-bullet"></span>`;
              },
            }}
            className="w-full h-full"
          >
            {slides.map((image) => (
              <SwiperSlide key={image}>
                <img
                  src={image}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Mobile Text */}
        <div className="bg-darkbg p-8">
          <Content navigate={navigate} />
        </div>
      </div>
    </section>
  );
};

export default Intro;
